/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
export const METADATA_KEY_SOURCE = 'source';

export const METADATA_SOURCE_THREAT_PACK = 'threatPack';
export const METADATA_KEY_SOURCE_THREAT_PACK = 'threatPackId';
export const METADATA_KEY_SOURCE_THREAT_PACK_THREAT = 'threatPackThreatId';

export const METADATA_SOURCE_MITIGATION_PACK = 'mitigationPack';
export const METADATA_KEY_SOURCE_MITIGATION_PACK = 'mitigationPackId';
export const METADATA_KEY_SOURCE_MITIGATION_PACK_MITIGATION = 'mitigationPackMitigationId';

export const METADATA_KEY_DESCRIPTION = 'Description';